import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { EASE_OUT, staggerContainer } from '../lib/motion';
import './TextReveal.css';

const unitVariant = {
  hidden: { y: '110%', rotate: 4 },
  show: { y: '0%', rotate: 0, transition: { duration: 0.6, ease: EASE_OUT } },
};

// Masked line reveal: words/chars slide up from behind an overflow-hidden
// word mask. Screen readers get the plain string via aria-label.
const TextReveal = ({
  as = 'span',
  text,
  className = '',
  mode = 'words',
  delay = 0,
  stagger,
  inView = false,
}) => {
  const reducedMotion = useReducedMotion();
  const MotionTag = motion[as] ?? motion.span;
  const Tag = as;

  if (reducedMotion) {
    return <Tag className={className}>{text}</Tag>;
  }

  const words = text.split(' ');
  const staggerAmount = stagger ?? (mode === 'chars' ? 0.03 : 0.08);
  const trigger = inView
    ? { whileInView: 'show', viewport: { once: true, margin: '-60px' } }
    : { animate: 'show' };

  return (
    <MotionTag
      className={className}
      aria-label={text}
      variants={staggerContainer(staggerAmount, delay)}
      initial="hidden"
      {...trigger}
    >
      {words.map((word, wi) => (
        <React.Fragment key={wi}>
          <span className="text-reveal__word" aria-hidden="true">
            {mode === 'chars' ? (
              word.split('').map((ch, ci) => (
                <motion.span key={ci} className="text-reveal__unit" variants={unitVariant}>
                  {ch}
                </motion.span>
              ))
            ) : (
              <motion.span className="text-reveal__unit" variants={unitVariant}>
                {word}
              </motion.span>
            )}
          </span>
          {wi < words.length - 1 ? ' ' : ''}
        </React.Fragment>
      ))}
    </MotionTag>
  );
};

export default TextReveal;
